// src/components/tasks/ui/TaskStatisticsDialogUI.tsx
import { cn } from "@/lib/utils"

export const statisticsTheme = {
  // Основное окно статистики — стекло
  dialogContent: "bg-purple-950/65 backdrop-blur-2xl border border-purple-300/40 text-white max-w-6xl h-[92vh] p-0 overflow-hidden flex flex-col",

  // Шапка
  header: "px-8 py-6 border-b border-purple-300/30 bg-purple-950/60 backdrop-blur-2xl shrink-0",

  // Заголовок
  title: "text-3xl font-bold text-center",

  // Карточка сотрудника — стекло
  employeeCard: "bg-purple-950/70 backdrop-blur-2xl border border-purple-300/40 rounded-3xl p-8",

  // Блоки статистики (4 колонки) — glass
  statBlock: (color: "purple" | "pink" | "amber" | "emerald") => {
    const base = "rounded-3xl p-6 text-center border backdrop-blur-xl"
    if (color === "purple") return cn(base, "bg-purple-900/70 border-purple-300/40")
    if (color === "pink") return cn(base, "bg-pink-900/70 border-pink-300/40")
    if (color === "amber") return cn(base, "bg-amber-900/70 border-amber-300/40")
    return cn(base, "bg-emerald-900/70 border-emerald-300/40")
  },

  // Текст внутри блока
  statLabel: "text-sm mb-1 text-purple-200",
  statValue: "text-5xl font-bold text-white",

  // Бейджи статусов
  badgeNew: "bg-red-600 text-white px-5 py-1.5 text-base rounded-2xl",
  badgeAccepted: "bg-amber-600 text-white px-5 py-1.5 text-base rounded-2xl",
  badgeInReview: "bg-blue-600 text-white px-5 py-1.5 text-base rounded-2xl",
  badgeRework: "bg-purple-600 text-white px-5 py-1.5 text-base rounded-2xl",
} as const